import React, { Component } from 'react';
import { Button, Modal, Card } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import { Fetcher } from "../../../Helpers/fetcher.js";
import { Notify } from "../../../Helpers/notification.js";
import Dropdown from 'react-bootstrap/Dropdown';
import ToggleButton from 'react-toggle-button'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import Cookies from 'js-cookie';
import { Link } from "react-router-dom";

import "./index.css";
class TTSFlowList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            blacklist: [],
            confirmDelete: false,
            selectedBlId: 0,
            selectedFlowId : 0,
            sizePerPage: 10,
            ttsFlowList : []
        }
    }
    componentDidMount() {
        this.getTTSFlowlist();
        const savedSizePerPage = Cookies.get('webhookListsizePerPage');
        if (savedSizePerPage) {
            this.setState({ sizePerPage: Number(savedSizePerPage) });
        }
    }

    getTTSFlowlist = () => {
        const apiPath = this.props.app.apiPath;
        const userId = this.props.app.userId;
        Fetcher.get(apiPath + '/api/obd/tts/flow/list/'+userId)
            .then(res => {
                this.setState({
                    ttsFlowList: res,
                    confirmDelete: false,
                })
            })
            .catch(err => { console.log('Error in fetching TTS Flow List', err) });
    }

    confirmDelete = (status, blId) => {
        this.setState({
            confirmDelete: status,
            selectedFlowId: blId
        });
    }

    deleteTTSFlow = () => {
        const wId = this.state.selectedFlowId;
        const data = {

        }

        return Fetcher.post(this.props.app.apiPath + '/api/obd/tts/flow/'+wId, { headers: { "Content-type": "application/json" }, method: 'DELETE', body: JSON.stringify(data) })
                    .then(res => {
                        Notify.notify(res.message);
                        this.getTTSFlowlist();
                    })
                    .catch(err => {
                        console.log('Error in Deleting TTS Flow', err);
                        Notify.notify('Error in Deleting TTS Flow');
                    });
    }

    handleSizePerPageChange = (newSizePerPage) => {
        this.setState({ sizePerPage: newSizePerPage });
        Cookies.set('webhookListsizePerPage', newSizePerPage);
    }

    render() {

        const ttsFlowList = this.state.ttsFlowList;
        let columns = '';
        
            columns = [
                {
                dataField: 'id',
                text: 'Flow Id',
                sort: true,
                hidden : false
            },
            {
                dataField: 'flowName',
                text: 'Flow Name',
                sort: false,
                searchable: true
            },
            {
                dataField: 'templateId',
                text: 'Template',
                sort: true,
                searchable: true
            }, {
                dataField: 'status',
                text: 'Status',
                sort: false,
                searchable: true
            },
             { dataField: 'startDate',
                text: 'Start Date',
                sort: false,
                searchable: true
            },
            { dataField: 'enddate',
                text: 'End Date',
                sort: false,
                searchable: true
            },
             {
               dataField: 'createdAt',
                text: 'Created At',
                sort: false,
                searchable: true
            },
            {
                dataField: 'updatedAt',
                text: 'Updated At',
                sort: false,
                searchable: true
            },
             {
                dataField: 'action',
                text: 'Action',
                sort: false,
                searchable: false
            },];

        const flows = Array.isArray(ttsFlowList) ? ttsFlowList.map((blist, index) => {
            
            let template = "";
            if(blist.templateId==="7"){
                template = "TTS Simple IVR";
            }else if(blist.templateId==="8"){
                template = "TTS DTMF";
            }else if(blist.templateId==="9"){
                template = "TTS Call Patch";
            }

           let action = [ <Link data-tip="Edit TTS Flow" key={`${index}-edit-tts-flow`} className="edit-tts-flow" to={`${this.props.app.urlPrefix}/update-tts-flow/${blist.id}`}><i className="fa fa-edit"></i></Link> ];
			// let action = [];
            action.push(<a data-tip="Delete TTS Flow" key={`${index}-delete-tts-flow`} className="delete-tts-flow" onClick={( e ) => { this.confirmDelete( true, blist.id) }} href="#"><i className="fa fa-trash"></i></a>);
            return {
                id : blist.id,
                flowName: blist.ttsFlowName,
                templateId : template,
                status : (blist.status == "0" ? "Active" : "Deleted"),
                startDate : blist.startDate,
                enddate : blist.endDate,
                createdAt : blist.createdAt,
                updatedAt : blist.updatedAt,
                action: action
            };
        }) : []
        const { SearchBar, ClearSearchButton } = Search;

        const defaultSorted = [{
            dataField: 'id',
            order: 'desc'
        }];

        const paginationOption = {
            custom: true,
            totalSize: flows.length,
            sizePerPage: this.state.sizePerPage,
            sizePerPageList: [10, 25, 50, 100],
            onSizePerPageChange: this.handleSizePerPageChange
        };

        return (
            <Card>
                <Card.Header>TTS Flow List</Card.Header>
                <Card.Body>
                    <div className="campaign-list-table-cont">
                        {<PaginationProvider pagination={paginationFactory(paginationOption)}>
                            {
                                ({
                                    paginationProps,
                                    paginationTableProps
                                }) => (<ToolkitProvider keyField="flowId" data={flows} columns={columns} search bootstrap4>
                                    {props => (<div className="">
                                        Show <SizePerPageDropdownStandalone className="search-dropdown" {...paginationProps} /> items
                                        <span className="search-cont"><SearchBar {...props.searchProps} /></span>
                                        <ClearSearchButton className="btn-primary" {...props.searchProps} />
                                        <hr />
                                        <BootstrapTable bordered={true} hover condensed defaultSorted={defaultSorted} wrapperClasses="table-responsive" classes="blacklist-table" {...props.baseProps} {...paginationTableProps} noDataIndication={() => (<div>{'No data available'}</div>)} />
                                        <PaginationListStandalone {...paginationProps} />
                                    </div>)}
                                </ToolkitProvider>)
                            }
                        </PaginationProvider>}
                    </div>
                    <Modal size="md" show={this.state.confirmDelete} onHide={() => this.confirmDelete(false, '')}>
                        <Modal.Header closeButton>
                            <Modal.Title id="example-modal-sizes-title-sm">
                                Delete TTS Flow
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Are you sure you want to delete this TTS Flow?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={() => this.confirmDelete(false, '')} variant="secondary">CANCEL</Button>
                            <Button onClick={this.deleteTTSFlow} variant="primary">YES</Button>
                        </Modal.Footer>
                    </Modal>
                </Card.Body>
            </Card>
        );
    }
}


export default TTSFlowList;